import { action, observable, flow, makeObservable } from 'mobx';
import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { SpecialServicingService } from '../services/specialServicingService';
import { downloadDocument } from '@roc/feature-utils';
import { CounterPartyExpensesTab, Entity } from '../types/types';
import { ProtectiveAdvanceFormStore } from './protectiveAdvanceFormStore';

export class ProtectiveAdvancesStore {
  globalStore: GlobalStore;
  service: SpecialServicingService;
  tab: CounterPartyExpensesTab;
  protectiveAdvanceFormStore: ProtectiveAdvanceFormStore;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.service = new SpecialServicingService();
    this.tab = CounterPartyExpensesTab.PAYABLE;
    this.protectiveAdvanceFormStore = new ProtectiveAdvanceFormStore(globalStore, this.service);

    makeObservable(this, {
      setTab: action,
      tab: observable,
      protectiveAdvanceFormStore: observable,
    });
  };

  setTab(tab: CounterPartyExpensesTab) {
    this.tab = tab;
  };

}
